<template>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">MEGAPOS DATA</h3>
        </div>
      </div>
    </div>
</template>